'use client';

import React, { useState } from 'react';
import { Box, Button, Flex, Heading, LucideIcon } from '@skin-seoul/design-system';
import { CLASSNAME } from '@skin-seoul/service';
import ReadMoreContent from '@/components/ui/ReadMoreContent/ReadMoreContent';
import CategorySlider from '../CategorySlider';
import { useDynamicCategories } from '../../utils/categoryUtils';
interface CollectionIntroductionDesktopLayoutProps {
  title: string;
  introductionBody: string;
  category?: string;
  subcategory?: string;
}
const CollectionIntroductionDesktopLayout = ({
  title,
  introductionBody,
  category,
  subcategory
}: CollectionIntroductionDesktopLayoutProps) => {
  const {
    categories
  } = useDynamicCategories();
  const [isContentExpanded, setIsContentExpanded] = useState(false);
  const [forceCollapse, setForceCollapse] = useState(0);
  const handleViewAllCategories = () => {
    setIsContentExpanded(false);
    setForceCollapse(prev => prev + 1);
  };
  const currentParentCategory = category ? categories.find(cat => cat.slug === category) : null;
  const hasSubcategories = Boolean(currentParentCategory?.subCategories?.length);
  if (!hasSubcategories) {
    return <Flex direction="column" gap={4} display={{
      base: 'none',
      tablet: 'flex'
    }}>
        <Heading as="h1" textStyle="heading.h2" fontWeight="medium" color="neutral.700" className={CLASSNAME.NOT_TRANSLATE}>
          {title}
        </Heading>
        <Box textStyle={{
        base: 'paragraph.small',
        tablet: 'paragraph.medium'
      }} fontWeight="regular" color="neutral.600">
          <ReadMoreContent noOfLines={2} expandButtonText="more" collapseButtonText="less" ariaLabel="introduction text">
            <div dangerouslySetInnerHTML={{
            __html: introductionBody
          }} />
          </ReadMoreContent>
        </Box>
      </Flex>;
  }
  return <Flex direction={isContentExpanded ? 'column' : 'row'} gap={isContentExpanded ? 4 : 6} align="flex-start" display={{
    base: 'none',
    tablet: 'flex'
  }} data-sentry-element="Flex" data-sentry-component="CollectionIntroductionDesktopLayout" data-sentry-source-file="CollectionIntroductionDesktopLayout.tsx">
      <Box width={isContentExpanded ? '100%' : '320px'} flex={isContentExpanded ? '1' : '0 0 auto'} data-sentry-element="Box" data-sentry-source-file="CollectionIntroductionDesktopLayout.tsx">
        <Flex direction="column" gap={4} data-sentry-element="Flex" data-sentry-source-file="CollectionIntroductionDesktopLayout.tsx">
          <Heading as="h1" textStyle="heading.h2" fontWeight="medium" color="neutral.700" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Heading" data-sentry-source-file="CollectionIntroductionDesktopLayout.tsx">
            {title}
          </Heading>

          <Flex justify="space-between" align="flex-start" gap={6} data-sentry-element="Flex" data-sentry-source-file="CollectionIntroductionDesktopLayout.tsx">
            <Box textStyle={{
            base: 'paragraph.small',
            tablet: 'paragraph.medium'
          }} fontWeight="regular" color="neutral.600" data-sentry-element="Box" data-sentry-source-file="CollectionIntroductionDesktopLayout.tsx">
              <ReadMoreContent key={forceCollapse} noOfLines={2} expandButtonText="more" collapseButtonText="less" ariaLabel="introduction text" onExpandedChange={setIsContentExpanded} data-sentry-element="ReadMoreContent" data-sentry-source-file="CollectionIntroductionDesktopLayout.tsx">
                <div dangerouslySetInnerHTML={{
                __html: introductionBody
              }} />
              </ReadMoreContent>
            </Box>
            {isContentExpanded && <Button variant="outline" size="sm" onClick={handleViewAllCategories} borderColor="primary.75" color="neutral.700" borderRadius="50%" height="108px" width="108px" textWrap="auto" textStyle="label.small" fontWeight="regular" backgroundColor="primary.75" flexDirection="column">
                <LucideIcon name="ChevronLeft" strokeWidth={1} />
                View all Categories
              </Button>}
          </Flex>
        </Flex>
      </Box>

      {!isContentExpanded && <Box flex="1" minWidth={0}>
          <CategorySlider activeCategory={category} subcategory={subcategory} />
        </Box>}
    </Flex>;
};
export default CollectionIntroductionDesktopLayout;